/**
 * Which variant of each slot a preview is showing. Channel-neutral: the email
 * preview materializes these into HTML, the message preview resolves them per
 * fragment, and both resolve through the same `effectiveSelection` the backend
 * uses — so a previewed combination is always one a recipient can receive.
 */
import { slotVariants, type DynamicSlot, type SlotVariant } from "./slot-types";

/** slotId → the branch to preview.
 *
 * Keyed by BRANCH, not variant, because `effectiveSelection` is shared with
 * the backend's materialize. Pickers that list variants store the variant's
 * first branch id (`variantSelectionBranchId`). Sparse: a slot with no entry
 * previews its first branch in waterfall order. */
export type SlotSelections = Record<string, string>;

/** The branch id a variant picker stores as its selection — the variant's
 * first branch, since every branch sharing a content row renders the same. */
export function variantSelectionBranchId(
  variant: SlotVariant,
): string | undefined {
  return variant.branchIds[0];
}

/** How many distinct messages the slots can produce — the product of each
 * slot's VARIANT count. Conditions sharing a content row render identically,
 * so counting branches would report combinations the reader can't tell
 * apart. */
export function combinationCount(slots: DynamicSlot[]): number {
  return slots.reduce(
    (count, slot) => count * (slotVariants(slot.branches).length || 1),
    1,
  );
}
